import { Component, Input, OnInit, inject, signal } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, UrlSegment } from '@angular/router';
import { Button } from '../../button/button.component';
import { Titledescription } from '../../titledescription/titledescription.component';
import { Divider } from '../../divider/divider.component';
import { ApiService } from '../../../../core/api.service';
import { TituloInterface } from '../../../../models/titulo.model';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-crud-view',
  imports: [CommonModule, MatListModule, Button, Titledescription, Divider , MatProgressSpinner],
  templateUrl: './view.html',
  styleUrl: './view.scss'
})
export class CrudViewComponent{
  @Input() data !: {[key:string]:any}
  @Input() columnNames!: any[];
  @Input() backButton: boolean = true;
  @Input() actionButtons: boolean = true;
  @Input() templateHeaderDescription !: any;
  @Input() useCompactVersion: boolean = false;
  take: number = 0;
  skip: number = 0;

  getColumnLabel(key: string): string {
    const col = this.columnNames?.find((c: any) => c.name === key);
    return col?.label || key;
  }
  @Input() id?: number;
  idFromUrl = signal('');
  backUrl = signal('');
  private activatedRoute = inject(ActivatedRoute);
  private subscriptions: Subscription[] = [];
  constructor() {

    const paramsSub = this.activatedRoute.params.subscribe((params) => {
      if (this.id === undefined) {
          this.idFromUrl.set(params['id']);
        }
    });
    this.subscriptions.push(paramsSub);
    const urlSub = this.activatedRoute.url.subscribe((UrlSegment: UrlSegment[]) => {
      this.backUrl.set(UrlSegment[0].path);
    });
    this.subscriptions.push(urlSub);
     // Recibe take y skip desde query params
    const querySub = this.activatedRoute.queryParams.subscribe(params => {
      const take = params['take'];
      const skip = params['skip'];
      this.take = take;
      this.skip = skip;
    });
    this.subscriptions.push(querySub);
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  getValue(data: any, path: string, pipeName?: string): any {
    const value = path.split('.').reduce((acc, part) => acc && acc[part], data);
    if (!pipeName) return value;
    switch (pipeName) {
      case 'date':
        return value ? new Date(value).toLocaleDateString() : value;
      // Puedes agregar más pipes aquí si lo necesitas
      default:
        return value;
    }
  }
}
